<template>
	<div class="mobile-loan">
		<div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
		<atom-spinner
		  v-if="loading"
		  :animation-duration="speed"
		  :size="config.size"
		  :color="spinnersColor"
		/>
	  </div>
	  <div class="mb-3" v-if="processingError">
		<va-notification color="danger" closeable>       
		  An error occurred! Please Try again later.
		</va-notification>
	  </div>
		<div class="row">
			<div class="flex xs12 md6 lg6">
				<va-card :title="`Loan Limit: ${limitc}`">
				  <form @submit.prevent="onsubmit">
					  <va-input
						:label="$t('amount')"
						type="number"
						:max="limit"
						:min="5000"
						v-model="formdata.amount"
						:error="!!amountErrors.length"
						:error-messages="amountErrors"
						@input="LoadSelected"
					  />
  
					  <va-select
			  class="mb-4"
			  label="Payment Method"
			  v-model="formdata.periods"
			  textBy="description"
			  :options="PaymentPeriods"
			  key-by="id"            
			/>
					  <div class="row mt-5">            
						<va-button type="submit" >
						  {{ $t('forms.controls.submit') }}
						</va-button>                        
					  </div>
				  </form>
			  </va-card>
		  </div>
		</div>
		<va-modal
		v-model="showConfirmModal"
		position="top"
		size = "medium"
		:title=" $t('confirm_trans')"
		cancelClass="none"      
		:okText=" $t('modal.confirm') "     
		:cancelText=" $t('modal.cancel')"      
		noOutsideDismiss
		noEscDismiss
		@ok = "FinalPost"
	  >
		  <table class="va-table va-table--striped va-table--hoverable" width="100%">
			  <tbody>
				<tr>
				  <td>Loan Amount</td>
				  <td style="text-align: right;">{{ formdata.amount }}</td>
				</tr>
			  </tbody>
		  </table>
	  </va-modal>
	</div>
  </template>
  <script>
	  import axios from 'axios'
	  import * as spinners from 'epic-spinners'
	  export default {
		  components: {
			  ...spinners      
		  },
		  name: 'mobile-loan',
		  data () {
			  return {
				  userData: JSON.parse(localStorage.getItem('LoggedUser')),
				  accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
				  token: JSON.parse(localStorage.getItem('Token')),
				  loading: false,
				  limit:0,
				  limitc:0,
				  processingError: false,
				  loadSelect:false,
				  showConfirmModal : false,
				  amountErrors : [],
				  formdata:{
			  amount:'',
			  periods:'',
			  user: ''	        
			  },
			  PaymentPeriods: [
			  {
				id: '',
				description: 'select an Option',
			  },
			  {
				id: '3',
				description: '3 Months',
			  }
			],
			  amountErrors : [],
			  periodErrors : [],
			  config: {
				  size: 80,
				  duration: 1500,
			  },
			  spinnersColor: this.$themes.secondary,
			  currentDuration: 1500,
			  sliderDuration: {
				  min: 1000,
				  max: 2000,
			  },
			  }
		  },
		  computed: {
			  speed () {
				return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
			  },
  
			  formReady () {
				  return !this.amountErrors.length
			  }
		  }, 
		  methods : {
			  getLoanLimit(){
				  this.loading = true
				  var self = this
  
				  let config = {
			headers: {
			  Authorization: this.userData.user_id+' '+this.token
			}
		  }
  
				  axios.post(`${this.$apiUrl}GetLoanLimit`, this.userData.user_id, config)
				  .then(function (res) {
					  self.loading = false					
					  const resp = parseInt(res.data);
					  self.limit = resp;
					  self.limitc = self.$options.filters.Currency(resp)					             
					  self.showToast(`Your loan limit is ${resp}`, {
						  position: 'bottom-right',
						  icon: "fa-check",
						  duration: 10000,
					  })
									   
				  })
				  .catch(function (error) {
					console.log(error)
				  })
			  },
  
			  onsubmit () {
				console.log(this.formdata.amount);
				  this.processingError = false;
				  this.amountErrors = this.formdata.amount ? [] : ['Amount is required']
				  this.amountErrors = this.formdata.amount <= this.limit? [] : ['Amount is more than your loan limit']			
  
				  if (this.formReady) {
					  this.showConfirmModal = true;					
				  }
			  },
			  FinalPost () {
				  this.loading = true
				  var self = this
  
				  let config = {
			headers: {
			  Authorization: this.userData.user_id+' '+this.token
			}
		  }
  
		  const postdata = {
			  amount:this.formdata.amount,
			  periods:this.formdata.periods.id,
			  user:this.formdata.user
		  } 
  
				  axios.post(`${this.$apiUrl}GetLoan`, postdata, config)
				  .then(function (res) {
					  self.loading = false					
					  const resp = res.data;
					  console.log(resp);
					  if(resp.success == '1'){              
						self.showToast(`Loan Processed succefully`, {
						  position: 'bottom-right',
						  icon: "fa-check",
						  duration: 2500,
						})
						localStorage.removeItem('UserFosas')
						setTimeout( () => self.$router.push({ name: 'dashboard' }), 2500);
					  } else {
						self.processingError = true
					  }     
					  
									   
				  })
				  .catch(function (error) {
					console.log(error)
				  })
			  },
  
			  LoadSelected(value) {
				  value = parseInt(value)			
				  this.PaymentPeriods = [
				  {
				id: '',
				description: 'select an Option',
			  },
			  {
				id: '3',
				description: '3 Months',
			  }
			  ];
  
				  if(value >= 30001){
					  this.PaymentPeriods.push({
						  id:'4',
				description: '4 Months',
					  });
				  }
  
				  if(value >= 40001){
					  this.PaymentPeriods.push({
						  id:'5',
				description: '5 Months',
					  });
				  }
			  }      
		  },
  
		  created () { 
			  this.formdata.phone_no  = this.userData.mobile_number
			  this.formdata.user  = this.userData.user_id
			  this.getLoanLimit();    
		  } 
	  } 
  </script>